import { formatDistanceToNow, format } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';
import i18n from '@/lib/i18n/config';

/** Active date-fns locale, tracking the i18next chrome language (spec §5.3 / §6). */
function activeDateLocale() {
  return i18n.language === 'ar' ? ar : enUS;
}

/** Human-readable byte size with thin-space unit (DESIGN numeric voice). */
export function formatBytes(bytes: number): string {
  if (!bytes) return '0\u2009B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value < 10 && i > 0 ? 1 : 0)}\u2009${units[i]}`;
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: activeDateLocale() });
  } catch {
    return '—';
  }
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return format(new Date(iso), 'yyyy-MM-dd HH:mm');
  } catch {
    return '—';
  }
}
